import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getCodigoOfertaFormatada } from '../../../utils';
import GridBase from '../../../components/grid_base';
import { getOfertasVagasTrabalhos, getCombosListarVagas } from './atendimentos.service';
import { FiltrosVagas } from '../components/FiltrosVagas';
var COLUNAS = [
    {
        field: 'id',
        headerName: 'Código',
        description: 'Código da Oferta',
        width: 100,
        valueGetter: function (_value, row) { return "".concat(getCodigoOfertaFormatada(row.id)); },
    },
    {
        field: 'descricao',
        headerName: 'Vaga',
        description: 'Descrição da Oferta',
        width: 200,
    },
    {
        field: 'instituicao',
        headerName: 'Instituição',
        width: 250,
        valueGetter: function (_value, row) { var _a, _b; return (_b = (_a = row.instituicao) === null || _a === void 0 ? void 0 : _a.dados) === null || _b === void 0 ? void 0 : _b.razao_social; },
    },
    {
        field: 'vagas_qtd',
        headerName: 'QTD',
        description: 'Quantidade de Vagas Solicitadas',
        width: 100,
    },
    {
        field: 'situacao_oferta',
        headerName: 'Status',
        description: 'Status da Oferta',
        width: 150,
        valueGetter: function (value) { return value; },
    },
];
export var AtendimentosListar = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.ATENDIMENTOS, paginaPermissao: FUNCIONALIDADES.ATENDIMENTOS, rota: ROUTES.ATENDIMENTOS, columns: COLUNAS, hideAddButton: true, botoesAcoesCustomizados: function (acoesPermitidas) { return ({
            ROTA: ROUTES.ATENDIMENTOS,
            VISUALIZAR: acoesPermitidas === null || acoesPermitidas === void 0 ? void 0 : acoesPermitidas['VISUALIZAR'],
            ALTERAR: acoesPermitidas === null || acoesPermitidas === void 0 ? void 0 : acoesPermitidas['ALTERAR'],
            EXCLUIR: false,
        }); }, filtrosIniciais: {
            status: '-1',
            instituicao: -1,
            perfilLaboral: -1,
            dataInicio: '',
            dataFim: '',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            var _a, _b;
            return getOfertasVagasTrabalhos(textoBusca, filtros.status === '-1' ? null : filtros.status, filtros.instituicao === -1 ? null : (_a = filtros.instituicao) === null || _a === void 0 ? void 0 : _a.toString(), filtros.perfilLaboral === -1 ? null : (_b = filtros.perfilLaboral) === null || _b === void 0 ? void 0 : _b.toString(), filtros.dataInicio === '' ? null : filtros.dataInicio, filtros.dataFim === '' ? null : filtros.dataFim, 'Semiaberto', paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(FiltrosVagas, { filtrosAtuais: filtros, atualizarFiltros: atualizarFiltros, getCombosListar: getCombosListarVagas })); } }));
};
export default AtendimentosListar;
